export default __webpack_public_path__ + "static/media/SUPER_.bc9159f4.png";